<script>
	import request from "$misc/request";
	const key = "6Ldjba0UAAAAAGC83zgvDDTouGNYBrp2zTlopaF_";
	const parameters = { action: "free_trial" };

	export const validateInteraction = (data = parameters) => {
		console.log("Generating reCaptcha token...");

		return grecaptcha.execute(key, data).then(async (token) => {
			const data = { recaptcha_response: token };
			console.log("Validating reCaptcha token server-side...");

			return (await request("api/validate_captcha.php", data)).match({
				left: (error) => (console.log(error), false),
				right: (data) => data.includes("success"),
			});
		});
	};
</script>

<svelte:head>
	<script
		type="text/javascript"
		src="https://www.google.com/recaptcha/api.js?render=6Ldjba0UAAAAAGC83zgvDDTouGNYBrp2zTlopaF_">
	</script>
</svelte:head>
